import { Injectable } from '@angular/core';
import { AuthToken } from '../models/auth-token';
import { SessionStorageUtils } from '../../shared/utils/session-storage.utils';
import { IDS_TOKEN } from '../constants/constants';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private authToken: AuthToken = {
    idToken: SessionStorageUtils.get(IDS_TOKEN) ?? null,
    mpToken: null,
    fluencyToken: null,
    screenerToken: null,
    phonicsToken: null,
    lsToken: null,
    lsShardKey: null,
  };

  public setAuthToken(authToken: Partial<AuthToken>) {
    this.authToken = { ...this.authToken, ...authToken };

    // Store ID token in session for when browser reloads
    if (authToken.idToken) {
      SessionStorageUtils.save(IDS_TOKEN, authToken.idToken);
    }
  }

  public getAuthToken(): AuthToken {
    return this.authToken;
  }

  public getAuthTokenByKey(key: keyof AuthToken): string {
    return this.authToken[key];
  }

  public isAuthenticatedForAuthType(key: keyof AuthToken) {
    return !!this.authToken[key];
  }

  public clearAuthToken() {
    this.authToken = {
      idToken: null,
      mpToken: null,
      fluencyToken: null,
      screenerToken: null,
      phonicsToken: null,
      lsToken: null,
      lsShardKey: null,
    };
    SessionStorageUtils.clear();
  }
}
